import { createContext, useContext, useEffect } from "react";

const LangContext = createContext("ru");

export const LangScope = ({ lang, children }) => {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
export const usePrefix = () => (useContext(LangContext) === "ru" ? "/ru" : "");
export const useT = () => STR[useContext(LangContext)];

export const STR = {
  ru: {
    nav: {
      services: "Услуги",
      works: "Работы",
      monferrato: "Монферрато",
      studio: "Студия",
      contact: "Контакты",
      gallery: "Галерея",
      cta: "Обсудить проект",
      brandAlt: "Monferrato Way",
    },
    hero: {
      kicker: "Монферрато · Пьемонт · Италия",
      lines: ["Найдём дом.", "Восстановим его.", "Сделаем вашим."],
      subtext:
        "Project Works – итальянская студия архитектуры. Сопровождаем поиск, покупку и реставрацию домов и вилл на севере Италии: от первого звонка до ключей. Говорим на русском, итальянском и английском.",
      ctaPrimary: "Обсудить проект",
      ctaSecondary: "Смотреть работы",
      imgAlt: "Вилла среди холмов Пьемонта",
    },
    marquee: ["Архитектура", "Реставрация", "Дизайн интерьера", "Пьемонт", "Монферрато", "Недвижимость"],
    services: {
      kicker: "Что мы делаем",
      headingA: "Полный цикл работ –",
      headingEm: "под ключ",
      subtext: "Один партнёр вместо пяти подрядчиков: от первой идеи до дома, в который можно заехать.",
      items: [
        {
          n: "01",
          title: "Поиск недвижимости",
          text: "Мы не агентство и не продаём каталоги. Ищем дома и виллы под вашу задачу – включая то, чего нет в открытой продаже, – и оцениваем их глазами архитектора.",
        },
        {
          n: "02",
          title: "Экспертиза перед покупкой",
          text: "Техническая проверка: состояние конструкции, разрешение на расширение, ограничения по градостроительству в конкретной зоне, реальный бюджет всех работ – до подписания контракта.",
        },
        {
          n: "03",
          title: "Сопровождение сделки",
          text: "Работаем с нотариусами, юристами и топографами, ведем переговоры о цене и защищаем ваши интересы на каждом этапе. Очно и дистанционно, на русском языке.",
        },
        {
          n: "04",
          title: "Проект реставрации",
          text: "Создадим проект для строительства с нуля или план реставрации существующего здания. Совместим обаяние сельского дома и натуральных материалов с современными технологиями и комфортом. Учитываем нюансы местности и локальные нормы градостроительства.",
        },
        {
          n: "05",
          title: "Управление стройкой",
          text: "Авторский надзор, проверенные подрядчики, сметы и сроки. Вы получаете регулярные отчёты и фотографии с объекта, где бы ни находились.",
        },
        {
          n: "06",
          title: "Не только дома",
          text: "Хотите инвестировать в производство знаменитых итальянских вин? Занимаемся поиском и проектированием виноделен, ресторанов и отелей.",
        },
      ],
    },
    portfolio: {
      kicker: "Наши проекты",
      headingA: "Дома, которые мы",
      headingEm: "вернули к жизни",
      subtext: "Каждый проект — это диалог между историей здания и жизнью его новых владельцев.",
      allWorks: "Смотреть все работы",
      works: [
        { img: "/images/work-cascina.webp", title: "Вилла на холме", place: "Полная реконструкция" },
        { img: "/images/work-pool.webp", title: "Дом для отпуска и не только", place: "Полная реконструкция" },
        { img: "/images/work-living.webp", title: "Гостиная под кирпичными сводами", place: "Реставрация интерьеров" },
        { img: "/images/work-kitchen.webp", title: "Современная кухня в старинных стенах", place: "Дизайн интерьера" },
      ],
    },
    monferrato: {
      kicker: "Территория",
      headingA: "Монферрато — Италия, которую вы",
      headingEm: "искали",
      p1: "Мягкие холмы между Турином и Генуей. Барбера и Бароло, белый трюфель, средневековые борго и тишина, которой нет на побережье. Здесь всё ещё можно купить исторический дом с видом на виноградники — по цене квартиры на окраине большого города.",
      p2: "Мы живём и работаем здесь. Мы знаем каждую коммуну, каждого нотариуса и каждого мастера по камню — и делимся этим знанием с вами.",
      imgAlt: "Закат над виноградниками Монферрато",
      stats: [
        { value: "1 час", label: "до Милана и Турина" },
        { value: "ЮНЕСКО", label: "пейзаж под охраной с 2014 года" },
        { value: "−40%", label: "к ценам Тосканы при той же красоте" },
      ],
    },
    manifesto: {
      kicker: "наша студия",
      headingLink: "Project Works",
      headingRest: " – студия архитектуры из Пьемонта",
      intro:
        "Мы много лет работаем с клиентами из Северной Европы, которые выбирают Италию не для отпуска, а для жизни. Теперь говорим с вами на русском — и берём на себя всё, что обычно пугает в покупке и строительстве дома за границей.",
      badgeCta: "Перейти на studioprojectworks.com",
    },
    contact: {
      kicker: "Контакты",
      heading: "Расскажите о вашем проекте",
      subtext: "Первая консультация — бесплатно и ни к чему не обязывает. Отвечаем в течение 24 часов.",
      emailLabel: "Email",
      name: "Ваше имя *",
      namePh: "Как к вам обращаться",
      email: "Email *",
      phone: "Телефон",
      phonePh: "+7 ...",
      subject: "Тема",
      subjectPh: "Например: покупка дома в Монферрато",
      message: "О вашем проекте *",
      messagePh: "Например: вилла с бассейном и видом на виноградники, площадь примерно 250 м²",
      privacyA: "Я принимаю",
      privacyLink: "политику конфиденциальности",
      privacyB: "и соглашаюсь на обработку данных для ответа на заявку *",
      submit: "Отправить заявку",
      sending: "Отправляем…",
      success: "Спасибо! Мы ответим вам в течение 24 часов.",
      error: "Не удалось отправить заявку. Напишите нам на info@monferratoway.com.",
    },
    footer: {
      tagline: "Поиск, покупка и реставрация домов в Монферрато. Пьемонт, Италия.",
      contactLink: "Связаться с нами",
      privacy: "Конфиденциальность",
      cookies: "Cookies",
    },
    gallery: {
      kicker: "Галерея",
      headingA: "Наши работы",
      headingEm: "в Монферрато",
      subtext:
        "Дома и виллы, которые мы нашли, спроектировали и восстановили для наших клиентов. Нажмите на фотографию, чтобы рассмотреть её ближе.",
      imgAlt: "Реализованный проект Monferrato Way",
      ctaHeading: "Хотите такой дом?",
      ctaText: "Расскажите нам о вашей мечте — первая консультация бесплатна.",
      ctaButton: "Обсудить проект",
      close: "Закрыть",
      prev: "Предыдущее фото",
      next: "Следующее фото",
    },
    seo: {
      homeTitle: "Monferrato Way — Поиск, покупка и реставрация домов в Монферрато",
      homeDesc:
        "Project Works: находим, покупаем и восстанавливаем дома и виллы в Монферрато, Пьемонт. Полное сопровождение на русском языке — от первого звонка до ключей.",
      galleryTitle: "Галерея работ — Monferrato Way | Монферрато, Пьемонт",
      galleryDesc:
        "Реализованные проекты Monferrato Way: реставрация домов и вилл в холмах Монферрато, Пьемонт. Фотографии экстерьеров и интерьеров.",
      locale: "ru_RU",
    },
  },
  en: {
    nav: {
      services: "Services",
      works: "Projects",
      monferrato: "Monferrato",
      studio: "Studio",
      contact: "Contacts",
      gallery: "Gallery",
      cta: "Discuss your project",
      brandAlt: "Monferrato Way",
    },
    hero: {
      kicker: "Monferrato · Piedmont · Italy",
      lines: ["We find the house.", "We bring it back to life.", "We make it yours."],
      subtext:
        "Project Works — an Italian architecture studio. We guide the search, purchase and restoration of houses and villas in Northern Italy: from the first call to the keys. We speak English, Italian and Russian.",
      ctaPrimary: "Discuss your project",
      ctaSecondary: "See our work",
      imgAlt: "Villa among the hills of Piedmont",
    },
    marquee: ["Architecture", "Restoration", "Interior design", "Piedmont", "Monferrato", "Real estate"],
    services: {
      kicker: "What we do",
      headingA: "Full service —",
      headingEm: "turnkey",
      subtext: "One partner instead of five contractors: from the first idea to a house you can move into.",
      items: [
        {
          n: "01",
          title: "Property search",
          text: "We are not an agency and we don't sell catalogues. We search for houses and villas tailored to your brief — including properties that never reach the open market — and we assess them with an architect's eye.",
        },
        {
          n: "02",
          title: "Pre-purchase due diligence",
          text: "Technical assessment: structural condition, extension permits, local planning restrictions and a realistic budget for all the works — before you sign anything.",
        },
        {
          n: "03",
          title: "Transaction support",
          text: "We work with notaries, lawyers and surveyors, negotiate the price and protect your interests at every stage. In person or remotely, in English.",
        },
        {
          n: "04",
          title: "Design & restoration",
          text: "We design new builds or the restoration of existing buildings. We combine the charm of country houses and natural materials with modern technology and comfort, respecting local character and planning rules.",
        },
        {
          n: "05",
          title: "Construction management",
          text: "Site supervision, trusted contractors, budgets and timelines. You receive regular reports and photos from the site, wherever you are.",
        },
        {
          n: "06",
          title: "Not only houses",
          text: "Looking to invest in Italy's famous wine production? We search for and design wineries, restaurants and hotels.",
        },
      ],
    },
    portfolio: {
      kicker: "Our projects",
      headingA: "Houses we",
      headingEm: "brought back to life",
      subtext: "Every project is a dialogue between the building's history and the lives of its new owners.",
      allWorks: "View all projects",
      works: [
        { img: "/images/work-cascina.webp", title: "Hilltop villa", place: "Full reconstruction" },
        { img: "/images/work-pool.webp", title: "A holiday home — and more", place: "Full reconstruction" },
        { img: "/images/work-living.webp", title: "Living room under brick vaults", place: "Interior restoration" },
        { img: "/images/work-kitchen.webp", title: "Modern kitchen in ancient walls", place: "Interior design" },
      ],
    },
    monferrato: {
      kicker: "The land",
      headingA: "Monferrato — the Italy you were",
      headingEm: "looking for",
      p1: "Gentle hills between Turin and Genoa. Barbera and Barolo, white truffles, medieval villages and a silence you won't find on the coast. Here you can still buy a historic house overlooking vineyards — for the price of a flat on the outskirts of a big city.",
      p2: "We live and work here. We know every municipality, every notary and every stonemason — and we share that knowledge with you.",
      imgAlt: "Sunset over the vineyards of Monferrato",
      stats: [
        { value: "1 hour", label: "from Milan and Turin" },
        { value: "UNESCO", label: "protected landscape since 2014" },
        { value: "−40%", label: "compared to Tuscany prices, same beauty" },
      ],
    },
    manifesto: {
      kicker: "our studio",
      headingLink: "Project Works",
      headingRest: " — an architecture studio from Piedmont",
      intro:
        "We have spent years working with clients from Northern Europe who choose Italy not for a holiday, but for life. We take care of everything that usually frightens people about buying and building a home abroad.",
      badgeCta: "Visit studioprojectworks.com",
    },
    contact: {
      kicker: "Contacts",
      heading: "Tell us about your project",
      subtext: "The first consultation is free and comes with no obligations. We reply within 24 hours.",
      emailLabel: "Email",
      name: "Your name *",
      namePh: "What shall we call you?",
      email: "Email *",
      phone: "Phone",
      phonePh: "+44 ...",
      subject: "Subject",
      subjectPh: "E.g.: buying a house in Monferrato",
      message: "About your project *",
      messagePh: "E.g.: a villa with a pool and vineyard views, about 250 m²",
      privacyA: "I accept the",
      privacyLink: "privacy policy",
      privacyB: "and agree to the processing of my data to answer my enquiry *",
      submit: "Send enquiry",
      sending: "Sending…",
      success: "Thank you! We'll get back to you within 24 hours.",
      error: "Could not send your enquiry. Please write to us at info@monferratoway.com.",
    },
    footer: {
      tagline: "Search, purchase and restoration of houses in Monferrato. Piedmont, Italy.",
      contactLink: "Contact us",
      privacy: "Privacy",
      cookies: "Cookies",
    },
    gallery: {
      kicker: "Gallery",
      headingA: "Our work",
      headingEm: "in Monferrato",
      subtext: "Houses and villas we have found, designed and restored for our clients. Click a photo to take a closer look.",
      imgAlt: "Completed project — Monferrato Way",
      ctaHeading: "Want a home like this?",
      ctaText: "Tell us about your dream — the first consultation is free.",
      ctaButton: "Discuss your project",
      close: "Close",
      prev: "Previous photo",
      next: "Next photo",
    },
    seo: {
      homeTitle: "Monferrato Way — Find, buy and restore a house in Monferrato, Piedmont",
      homeDesc:
        "Project Works: we find, purchase and restore houses and villas in Monferrato, Piedmont. Full support in English — from the first call to the keys.",
      galleryTitle: "Project gallery — Monferrato Way | Monferrato, Piedmont",
      galleryDesc:
        "Completed projects by Monferrato Way: restoration of houses and villas in the hills of Monferrato, Piedmont. Exterior and interior photography.",
      locale: "en_GB",
    },
  },
};
